import instance from '../Service'

export default class Dashboard {
  static async get_dashboard() {
    return await instance.get('/dashboard/get_dashboard')
  }
  static async get_products_by_company() {
    return await instance.get('/product/get_product_by_company')
  }
}